module.exports = __webpack_public_path__ + "static/media/icon_anquan.be19773e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/icon_anquan.svg
// module id = 572
// module chunks = 0